import { httpClient, apiLinks } from '@app/utils';
import { ModifyRole, DataRoles, ParamsGetRole, Role } from '../models/role';

const getRoles = async (params: ParamsGetRole): Promise<DataRoles> => {
  const response = await httpClient.get<DataRoles>({
    url: apiLinks.admin.roleManagement.getSearch,
    params,
  });
  return response.data;
};

const createRole = async (model: ModifyRole): Promise<Role> => {
  const result = await httpClient.post<Role>({
    url: apiLinks.admin.roleManagement.createRole,
    data: model,
  });
  return result.data;
};

const updateRole = async (roleId: number, model: ModifyRole): Promise<Role> => {
  const result = await httpClient.put<Role>({
    url: apiLinks.admin.roleManagement.updateRole + roleId,
    data: model,
  });
  return result.data;
};

const getRoleDetail = async (id: number): Promise<Role> => {
  const result = await httpClient.get<Role>({
    url: apiLinks.admin.roleManagement.getRoleDetail + id,
  });
  return result.data;
};

const updateRoleStatus = async (
  id: number,
  isActive: boolean,
): Promise<Role> => {
  const response = await httpClient.put<Role>({
    url: apiLinks.admin.roleManagement.updateRoleStatus + id,
    params: {
      isActive,
    },
  });

  return response.data;
};

const customerService = {
  getRoles,
  createRole,
  updateRole,
  getRoleDetail,
  updateRoleStatus,
};

export default customerService;
